import { render, staticRenderFns } from "./_Id.vue?vue&type=template&id=27cb3084"
import script from "./_Id.vue?vue&type=script&lang=js"
export * from "./_Id.vue?vue&type=script&lang=js"
import style0 from "./_Id.vue?vue&type=style&index=0&id=27cb3084&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports